module.exports = __webpack_public_path__ + "resources/globe/blue-world-contrast.jpg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=resources/globe/blue-world-contrast.jpg!./src/resources/globe/blue-world-contrast.jpg
// module id = 2502
// module chunks = 0